import { render, staticRenderFns } from "./FinalMixItem.vue?vue&type=template&id=4da85cb2&scoped=true"
import script from "./FinalMixItem.vue?vue&type=script&lang=js"
export * from "./FinalMixItem.vue?vue&type=script&lang=js"
import style0 from "./FinalMixItem.vue?vue&type=style&index=0&id=4da85cb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da85cb2",
  null
  
)

export default component.exports